module.exports = __webpack_public_path__ + "img/ZonaMate_icone_Metodo_bianca.25a014dc.svg";